import { BrandService } from "./brand";

export default new BrandService(document.documentElement);
